module.exports = __webpack_public_path__ + "img/enteringCode.80691625.jpg";